import { Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { ITab, TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { EntityListAction, Permission, SaveReportFile } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer, VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { EntityBase, GridColumnInfoDetail } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { AccStatusKind, ReportKind, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, HttpCommonService, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { InvVoucherFormComponent } from "src/app/backoffice/inv/invvoucher/invvoucher-form/invvoucher-form.component";
import { SellVoucherFormComponent } from "src/app/backoffice/sell/sell-voucher/sell-voucher-form/sell-voucher-form.component";
import { TrsVoucherFormComponent } from "src/app/backoffice/trs/trs-voucher/trs-voucher-form/trs-voucher-form.component";
import { ReportInfo, StimulSoftReportComponent } from "src/app/stimul-soft-report/stimul-soft-report.component";
import { AccVoucherHeader } from "../../models/accvoucherheader.model";
import { VoucherInfo } from "../../models/voucherInfo.model";
import { VoucherApproveComponent } from "../../voucher-approve/voucher-approve.component";
import { AccVoucherDetailFilterComponent } from "../acc-voucher-detail-filter/acc-voucher-detail-filter.component";
import { AccVoucherHeaderImportExcelFormComponent } from "../acc-voucher-header-import-excel/acc-voucher-header-import-excel-form.component";
import { AccVoucherFormComponent } from "../accvoucher-form/accvoucher-form.component";
@Component({
  selector: "ngx-accvoucher-list",
  templateUrl: "./accvoucher-list.component.html",
  styles: [".list-wrapper { padding: 1vmin; height: 100% }"],
})
export class AccVoucherListComponent extends BaseListComponent {
  actions: EntityListAction[];
  @ViewChild("grid") grid: KGridComponent;
  filterInfo: NameValue[] = [];
  filters: GridFilter[];
  constructor(
    private _httpCommonService: HttpCommonService,
    private tabsservice: TabularService,
    private lookupservice: LookupService,
    private splashFormService: SplashFormService
  ) {
    super();
    this.inputEditorform = AccVoucherFormComponent;
    this.onActionClick = this.onActionClick.bind(this);
  }
  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.actions = undefined;
    this.filterInfo = undefined;
    this.filters = undefined;
  }
  ngOnInit() {
    this.lookupservice.getall();
    this.apiName = "AccVoucherHeader/GetWithCustomFilter";
    this.areaName = "Accounting";
    this.label = this.translate("ClientApp.BackOffice.ACC.AccVoucher.AccVoucherList");
    if (this.currentFiscalYear) {
      this.filterInfo.push({ Name: "FiscalYearId", Value: this.currentFiscalYear?.Id, Operator: "eq" });
      this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.filterInfo.push({ Name: "FiscalYearId", Value: x.Id, Operator: "eq" });
          this.filterInfo.push({ Name: "BranchId", Value: this.accountService.authService.currentBranchId, Operator: "eq" });
        }
      });
    this.setactions();
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: AccVoucherHeader,
    onRowsSelected: AccVoucherHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    ///شماره گذاری اسناد
    if (action.name === "VoucherRenumber") {
      this._httpCommonService
        .get<AccVoucherHeader>("AccVoucherHeader/VoucherRenumber/" + this.accountService.authService.currentFiscalYear.Id + "/")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.sts.showDialog("اسناد شماره گذاری شد.", "");
            this.tabsservice.tabItemonRefreshData.next(this.apiName);
          },
          (error) => this.sts.showDialog(`خطا در شماره گذاری اسناد ${Utilities.getHttpResponseMessage(error)}`, "خطا")
        );
    }
    ///ثبت یاداشت اسناد
    if (action.name === "VoucherWrite" && onRowsSelected.length > 0) {
      if (isAllSelected) {
        const voucherInfo = new VoucherInfo();
        voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
        voucherInfo.BranchId = this.accountService.authService.currentBranchId;
        voucherInfo.StatusKindCode = AccStatusKind.Write;
        voucherInfo.FromStatusKindCode = AccStatusKind.Inspection;
        this.httpCommonService
          .create(this.apiName.split("/")[0] + "/ChnageStatusKind", voucherInfo)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.sts.showDialog("اسناد با موفقیت ثبت یاداشت شد.", "");
              this.tabsservice.tabItemonRefreshData.next(this.apiName);
            },
            (error) => this.sts.showDialog(`خطا در ثبت یاداشت اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
          );
      } else {
        onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === AccStatusKind.Inspection);
        if (!onRowsSelected || onRowsSelected.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا اسناد انتخاب شده قابل یاداشت شدن نیست", "خطا");
        }
        this.lookupservice
          .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Write)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((sk) => {
            if (sk) {
              onRowsSelected.forEach((x) => {
                x.StatusKindId = sk.Id;
                x.StatusKindCode = sk.Code;
                x.StatusKindTitle = sk.Title;
              });
              this.httpCommonService
                .bulkUpdate(this.apiName.split("/")[0], onRowsSelected)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (x) => {
                    this.sts.showDialog("اسناد با موفقیت ثبت یاداشت شد.", "");
                    this.tabsservice.tabItemonRefreshData.next(this.apiName);
                  },
                  (error) => this.sts.showDialog(`خطا در ثبت یاداشت اسناد ${Utilities.getHttpResponseMessage(error)}`, "خطا")
                );
            }
          });
      }
    }
    ///ثبت موقت اسناد
    if (action.name === "VoucherInspection" && onRowsSelected.length > 0) {
      if (isAllSelected) {
        const voucherInfo = new VoucherInfo();
        voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
        voucherInfo.BranchId = this.accountService.authService.currentBranchId;
        voucherInfo.StatusKindCode = AccStatusKind.Inspection;
        voucherInfo.FromStatusKindCode = AccStatusKind.Write;
        this.httpCommonService
          .create(this.apiName.split("/")[0] + "/ChnageStatusKind", voucherInfo)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.sts.showDialog("اسناد با موفقیت ثبت موقت شد.", "");
              this.tabsservice.tabItemonRefreshData.next(this.apiName);
            },
            (error) => this.sts.showDialog(`خطا در ثبت موقت اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
          );
      } else {
        onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === AccStatusKind.Write);
        if (!onRowsSelected || onRowsSelected.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده یاداشت نیست", "خطا");
        }
        this.lookupservice
          .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Inspection)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((sk) => {
            if (sk) {
              onRowsSelected.forEach((x) => {
                x.StatusKindId = sk.Id;
                x.StatusKindCode = sk.Code;
                x.StatusKindTitle = sk.Title;
              });
              this.httpCommonService
                .bulkUpdate(this.apiName.split("/")[0], onRowsSelected)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (x) => {
                    this.sts.showDialog("اسناد با موفقیت ثبت موقت شد.", "");
                    this.tabsservice.tabItemonRefreshData.next(this.apiName);
                  },
                  (error) => this.sts.showDialog(`خطا در ثبت موقت اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
                );
            }
          });
      }
    }
    ///بررسی کردن اسناد
    if (action.name === "VoucherConfirm") {
      if (isAllSelected) {
        const voucherInfo = new VoucherInfo();
        voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
        voucherInfo.BranchId = this.accountService.authService.currentBranchId;
        voucherInfo.StatusKindCode = AccStatusKind.Confirm;
        voucherInfo.FromStatusKindCode = AccStatusKind.Inspection;
        this.httpCommonService
          .create(this.apiName.split("/")[0] + "/ChnageStatusKind", voucherInfo)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.sts.showDialog("اسناد با موفقیت بررسی شد.", "");
              this.tabsservice.tabItemonRefreshData.next(this.apiName);
            },
            (error) => this.sts.showDialog(`خطا در بررسی اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
          );
      } else {
        onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === AccStatusKind.Inspection);
        if (!onRowsSelected || onRowsSelected.length <= 0) {
          this.sts.showDialog("هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده ثبت موقت نیست", "خطا");
        }
        this.lookupservice
          .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Confirm)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((sk) => {
            if (sk) {
              onRowsSelected.forEach((x) => {
                x.StatusKindId = sk.Id;
                x.StatusKindCode = sk.Code;
                x.StatusKindTitle = sk.Title;
              });
              this.httpCommonService
                .bulkUpdate(this.apiName.split("/")[0], onRowsSelected)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (x) => {
                    this.sts.showDialog("اسناد با موفقیت بررسی شد.", "");
                    this.tabsservice.tabItemonRefreshData.next(this.apiName);
                  },
                  (error) => this.sts.showDialog(`خطا در بررسی اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
                );
            }
          });
      }
    }
    ///لغو بررسی اسناد
    if (action.name === "VoucherDeConfirm") {
      if (isAllSelected) {
        const voucherInfo = new VoucherInfo();
        voucherInfo.FiscalYearId = this.accountService.authService.currentFiscalYear.Id;
        voucherInfo.BranchId = this.accountService.authService.currentBranchId;
        voucherInfo.StatusKindCode = AccStatusKind.Inspection;
        voucherInfo.FromStatusKindCode = AccStatusKind.Confirm;
        this.httpCommonService
          .create(this.apiName.split("/")[0] + "/ChnageStatusKind", voucherInfo)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.sts.showDialog("اسناد با موفقیت لغو بررسی شد.", "");
              this.tabsservice.tabItemonRefreshData.next(this.apiName);
            },
            (error) => this.sts.showDialog(`خطا در لغو بررسی اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
          );
      } else {
        onRowsSelected = onRowsSelected.filter((x) => x.StatusKindCode === AccStatusKind.Confirm);
        if (!onRowsSelected || onRowsSelected.length <= 0) {
          this.sts.showDialog("خطا", "هیچ سندی انتخاب نشده یا وضعیت اسناد انتخاب شده بررسی شده نیست");
        }
        this.lookupservice
          .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Inspection)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe((sk) => {
            if (sk) {
              onRowsSelected.forEach((x) => {
                x.StatusKindId = sk.Id;
                x.StatusKindCode = sk.Code;
                x.StatusKindTitle = sk.Title;
              });
              this.httpCommonService
                .bulkUpdate(this.apiName.split("/")[0], onRowsSelected)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(
                  (x) => {
                    this.sts.showDialog("اسناد با موفقیت لغو بررسی شد.", "");
                    this.tabsservice.tabItemonRefreshData.next(this.apiName);
                  },
                  (error) => this.sts.showDialog(`خطا در لغو بررسی اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
                );
            }
          });
      }
    }
    ///فیلتر اقلام سند
    if (action.name === "AccVoucherDetailFilter") {
      this.dialogService
        .open(
          AccVoucherDetailFilterComponent,
          {
            currentrow: null,
            apiName: this.apiName,
            areaName: this.areaName,
            label: this.label,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {
          if (model && model.length > 0) this.filters = model;
        });
    }
    if (action.name === "AccVoucherDetailFilterRemove") {
      this.filters = [];
    }
    ///سند مبنا
    if (action.name === "BaseVoucher") {
      var datatrasfer: Datatransfer = <Datatransfer>{};
      datatrasfer.apiName = action.apiName;
      datatrasfer.label = this.label;
      datatrasfer.areaName = action.areaName;
      datatrasfer.currentrow = onRowSelected;

      if (!onRowSelected.AccountingSubSystemsRelationships || onRowSelected.AccountingSubSystemsRelationships.length <= 0) {
        this.sts.showDialog("سند مبنا وجود ندارد.", "");
        return;
      } else if (onRowSelected.AccountingSubSystemsRelationships.length === 1) {
        if (onRowSelected.SystemKindCode === SystemKind.INV) {
          action.Form_Component = InvVoucherFormComponent;
          onRowSelected.Id = onRowSelected.AccountingSubSystemsRelationships[0].InvVoucherHeaderId;
          datatrasfer.apiName = "InvVoucherHeader";
          datatrasfer.areaName = "Inventory";
        }
        if (onRowSelected.SystemKindCode === SystemKind.TRS) {
          action.Form_Component = TrsVoucherFormComponent;
          onRowSelected.Id = onRowSelected.AccountingSubSystemsRelationships[0].TrsVoucherHeaderId;
          datatrasfer.apiName = "TrsVoucherHeader";
          datatrasfer.areaName = "Treasury";
        }
        if (onRowSelected.SystemKindCode === SystemKind.SELL) {
          action.Form_Component = SellVoucherFormComponent;
          //onRowSelected.Id=onRowSelected.AccountingSubSystemsRelationships[0].SellVoucherHeaderId;
          datatrasfer.apiName = "SellVoucherHeader";
          datatrasfer.areaName = "SellCustomer";
        }
      } else {
      }
      const menu = <ITab>{
        title: `${this.label}-(ویرایش)`,
        isCloseable: true,
        icon: action.iconName,
        active: true,
        responsive: true,
        componentType: action.Form_Component,
        data: [
          { provide: EntityBase, useValue: onRowSelected },
          { provide: Datatransfer, useValue: datatrasfer },
          { provide: VoucherKindInfo, useValue: <VoucherKindInfo>{ VoucherKindId: 0 } },
        ],
      };
      this.tabsservice.open(menu);
    }
    ///دریافت از اکسل
    if (action.name === "ImportFromExcel") {
      var gridInfo = this.getGridInfo();
      this.dialogService
        .open(
          action.Form_Component,
          {
            gridInfo: gridInfo,
            label: action.displayName,
          },
          {
            autoFocus: true,
            closeOnClickOutside: false,
          }
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((model: GridFilter[]) => {
          this.grid.refreshData();
        });
    }

    ///ارسال به راهکاران
    if (action.name === "SendAllAccVoucherToRakkaran") {
      this.splashFormService.openDialog("", "در حال ارسال به راهکاران");
      this.httpCommonService
        .get(action.apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog("ارسال به راهکاران با موفقیت انجام شد.", "");
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`خطا در ارسال به راهکاران  ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
    //پیش نمایش سند
    if (action.name === "PreviewVoucher" || action.name === "PrintVoucher") {
      let Ids: number[] = [];
      this.grid.selectedRows.forEach((x) => Ids.push(x.Id));
      this.splashFormService.openDialog("", "در حال چاپ سند");
      let saveReportFile: SaveReportFile = <SaveReportFile>{};
      saveReportFile.ReportTitle = this.label;
      saveReportFile.FileName = "AccountingDocument";
      saveReportFile.SystemKindName = "ACC";
      saveReportFile.CategoryName = action.apiName.replace("/", "_");
      this.httpCommonService
        .create(action.apiName, Ids)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (x) => {
            this.splashFormService.closeLoading();
            if (action.name === "PreviewVoucher") this.preview(saveReportFile, action.apiName, x as []);
            else this.print(saveReportFile, action.apiName, x as []);
          },
          (error) => {
            this.splashFormService.closeLoading();
            this.sts.showDialog(`خطا در چاپ سند  ${Utilities.getHttpResponseMessage(error)}`, "خطا");
          }
        );
    }
  }
  preview(saveReportFile: SaveReportFile, apiName: string, dataList: any[]): void {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.preview;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    reportInfo.pathPreFix = saveReportFile.SystemKindName;
    reportInfo.startDate = saveReportFile.startDate;
    reportInfo.endDate = saveReportFile.endDate;
    reportInfo.startNumber = saveReportFile.startNumber;
    reportInfo.endNumber = saveReportFile.endNumber;

    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  print(saveReportFile: SaveReportFile, apiName: string, dataList: any[]): void {
    let reportInfo: ReportInfo = <ReportInfo>{};
    reportInfo.reportKind = ReportKind.editReport;
    reportInfo.apiName = apiName;
    reportInfo.reportName = saveReportFile.FileName;
    reportInfo.dataList = dataList;
    reportInfo.saveReportFile = saveReportFile;
    const menu = <ITab>{
      title: saveReportFile.ReportTitle,
      isCloseable: true,
      active: true,
      responsive: true,
      componentType: StimulSoftReportComponent,
      data: [{ provide: ReportInfo, useValue: reportInfo }],
    };
    this.tabsservice.open(menu);
  }
  setactions() {
    this.actions = [
      {
        name: "VoucherRenumber",
        disabled: false,
        displayName: "شماره گذاری اسناد",
        iconName: "icon-format_list_numbered_rtl-o",
        apiName: "AccVoucherHeader/VoucherRenumber",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherWrite",
        disabled: false,
        displayName: "ثبت یاداشت اسناد",
        iconName: "icon-Takenote",
        apiName: "AccVoucherHeader/VoucherWrite",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherInspection",
        disabled: false,
        displayName: "ثبت موقت اسناد",
        iconName: "icon-Temporaryregister",
        apiName: "AccVoucherHeader/VoucherInspection",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherConfirm",
        disabled: false,
        displayName: "بررسی کردن اسناد",
        iconName: "icon-Documentreview",
        apiName: "AccVoucherHeader/VoucherConfirm",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherDeConfirm",
        disabled: false,
        displayName: "لغو بررسی اسناد",
        iconName: "icon-canceldocument",
        apiName: "AccVoucherHeader/VoucherConfirm",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "VoucherApprove",
        disabled: true,
        displayName: "قطعی کردن اسناد",
        iconName: "icon-fainally",
        Form_Component: VoucherApproveComponent,
        apiName: "AccVoucherHeader/VoucherApprove",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "AccVoucherDetailFilter",
        disabled: false,
        displayName: "فیلتر اقلام",
        iconName: "icon-filter-variant-plus",
        apiName: "AccVoucherHeader",
        areaName: "Accounting",
        permission: Permission.viewPermission,
      },
      {
        name: "AccVoucherDetailFilterRemove",
        disabled: false,
        displayName: "حذف فیلتر اقلام",
        iconName: "icon-filter-variant-minus",
        apiName: "AccVoucherHeader",
        areaName: "Accounting",
        permission: Permission.viewPermission,
      },
      {
        name: "BaseVoucher",
        disabled: false,
        displayName: "سند مبنا",
        iconName: "icon-folder-open-outline",
        areaName: "Accounting",
        Form_Component: AccVoucherFormComponent,
        apiName: "AccVoucherHeader",
      },
      {
        name: "ImportFromExcel",
        disabled: false,
        displayName: "ورودی اکسل",
        iconName: "icon-file-excel-o",
        apiName: "AccVoucherHeader/ImportExcel",
        areaName: "Accounting",
        Form_Component: AccVoucherHeaderImportExcelFormComponent,
        permission: Permission.samePermission,
      },
      {
        name: "PreviewVoucher",
        disabled: false,
        displayName: "پیش نمایش سند",
        iconName: "icon-preview-f",
        apiName: "AccVoucherHeader/PreviewVoucher",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
      {
        name: "PrintVoucher",
        disabled: false,
        displayName: "چاپ سند",
        iconName: "icon-print-f",
        apiName: "AccVoucherHeader/PrintVoucher",
        areaName: "Accounting",
        permission: Permission.samePermission,
      },
    ];
    this.actions.push({
      name: "SendAllAccVoucherToRakkaran",
      disabled: false,
      displayName: "ارسال به راهکاران",
      iconName: "icon-send-F",
      apiName: "AccVoucherHeader/SendAllAccVoucherToRakkaran",
      areaName: "Accounting",
      permission: Permission.samePermission,
    });
  }
  getParamsForExportExcelWithPostMethod(): Promise<any> {
    let Ids: number[] = [];

    this.grid.selectedRows.forEach((x) => Ids.push(x.Id));
    let filter = this.grid.getGridFilter();
    if (Ids.length > 0)
      filter.push({
        Filed: "Ids",
        Value: Ids,
        Operator: filter[0].Operator,
        Skip: filter[0].Skip,
        Take: filter[0].Take,
        Type: "F",
        Logic: filter[0].Logic,
      });
    return new Promise((resolve, reject) => {
      resolve({ GridInfo: this.getGridInfo(), Filters: filter });
    });
  }

  getGridInfo(): GridColumnInfoDetail[] {
    let columns: GridColumnInfoDetail[] = [];
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "VoucherNo", orderindex: 0, title: "شماره سند" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "ShamsiVoucherDate", orderindex: 1, title: "تاریخ سند" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "BranchCode", orderindex: 2, title: "کد شعبه" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "HeaderComment", orderindex: 3, title: "شرح سند" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "RowNumber", orderindex: 4, title: "ردیف" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "SubLedgerCode", orderindex: 5, title: "کد حساب معین" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DetailLedgerCode", orderindex: 6, title: "کد حساب تفصیلی 1" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DetailLedger2Code", orderindex: 7, title: "کد حساب تفصیلی 2" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DetailLedger3Code", orderindex: 8, title: "کد حساب تفصیلی 3" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DetailLedger4Code", orderindex: 9, title: "کد حساب تفصیلی 4" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "DetailLedger5Code", orderindex: 10, title: "کد حساب تفصیلی 5" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Comment", orderindex: 11, title: "شرح قلم" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Debit", orderindex: 12, title: "بدهکار" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "Credit", orderindex: 13, title: "بستانکار" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "TrackNo", orderindex: 14, title: "شماره پیگیری" });
    columns.push(<GridColumnInfoDetail>{ hidden: false, name: "ShamsiTrackDate", orderindex: 15, title: "تاریخ پیگیری" });
    return columns;
  }
}
